import { memo, useEffect, useState } from "react";

import { Button } from "primereact/button";
import { Chart } from "primereact/chart";

import ChartDataLabels from 'chartjs-plugin-datalabels';

const options = {
    maintainAspectRatio: false,
    plugins: {
        datalabels: {
            anchor: 'end',
            align: 'end',
            formatter: (value) => {
                return Intl.NumberFormat("pt-BR", {
                      maximumFractionDigits: 2,
                    }).format(value);
              },
            font: {
                size: 14,
                weight: 'bold',
            },
            color: "#2c3e50"
        }
    },
}

export const RevisaoGraficoSetorMes = memo(function RevisaoGraficoSetorMes({ data = [], setor, colProp = "p-col-6" }) {
    const [chartData, setChartData] = useState({});
    const [col, setCol] = useState(colProp);

    useEffect(() => {
        let labels = [];
        let values = [];

        let _data = [...data];

        if(setor === 3) {
            _data = _data.filter((element) => {
                return ![-2, -1, 11, 32].includes(element.cod_defeito);
            });
        }
        
        _data.forEach((item) => {
            let index = labels.findIndex((element) => {
                return element === item.descricao;
            });

            if(index === -1) {
                labels.push(item.descricao);
            }
        });

        labels.forEach((label) => {
            let dataF = _data.filter((element) => {
                return element.descricao === label;
            });

            let total = 0;

            dataF.forEach((item) => {
                total += parseFloat(item.soma);
            });

            values.push(total);
        });

        const _chartData = {
            labels: labels,
            datasets: [
                {
                    label: 'TOTAL POR TIPO DE DEFEITO',
                    data: values,
                    backgroundColor: "#2ecc71"
                }
            ]
        }

        setChartData(_chartData);
    }, [data]);

    return (
        <div className={col}>
            <Button 
                icon="pi pi-search"
                onClick={() => {
                    setCol(col === "p-col-6" ? "p-col-12" : "p-col-6")
                }}
            />
            <Chart 
                data={chartData}
                height="350px"
                width="100%"
                options={options}
                plugins={[ChartDataLabels]}
                type="bar"
            />
        </div>
    )
});